import { createFileRoute, useNavigate, Link } from '@tanstack/react-router'
import { CalendarDays, LogOut } from 'lucide-react'
import { toast } from 'sonner'
import { useAuth } from '@/hooks/useAuth'
import { usePageMeta } from '@/lib/use-document-meta'
import { secondaryButtonClass, primaryButtonClass } from '@/components/ui'
import { SyncCard } from '@/components/SyncCard'

export const Route = createFileRoute('/_authenticated/dashboard')({ component: DashboardPage })

function DashboardPage() {
  usePageMeta({
    path: '/dashboard',
    title: 'Your account — Lunara',
    description: 'Manage your Lunara account and encrypted sync settings.',
    noindex: true,
  })
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const onLogout = async () => {
    await logout.mutateAsync()
    toast.success('Signed out')
    navigate({ to: '/' })
  }

  return (
    <div className="bg-surface-0 min-h-screen">
      <div className="mx-auto max-w-3xl px-4 py-12">
        <Link to="/" className="text-text-secondary hover:text-primary text-sm font-medium">
          ← Back to Lunara
        </Link>

        <h1 className="text-text-primary mt-6 text-2xl font-bold">Your account</h1>
        <p className="text-text-secondary mt-1">
          Signed in as <span className="text-text-primary font-medium">{user?.email}</span>
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <div className="border-border bg-surface-1 rounded-2xl border p-5">
            <div className="text-text-primary flex items-center gap-2 font-semibold">
              <CalendarDays size={18} className="text-primary" /> Open the tracker
            </div>
            <p className="text-text-secondary mt-1 text-sm">
              Your local data is right where you left it.
            </p>
            <Link to="/tracker" className={`mt-4 ${primaryButtonClass}`}>
              Open tracker
            </Link>
          </div>

          <SyncCard />
        </div>

        <div className="mt-8">
          <button onClick={onLogout} className={secondaryButtonClass}>
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
